export default "__VITE_ASSET__DwntsWdA__"